import { Schema } from "@effect/schema";
import { BaseError, StaticMarket } from "@silo/types";
import { put } from "@vercel/blob";
import { Context } from "effect";

export class BlobClientError extends BaseError {
  public readonly _tag = "BlobClientError";
}

export class BlobService extends Context.Tag("BlobService")<
  BlobService,
  { put: typeof put }
>() {}

export type StaticMarketsFile = typeof StaticMarketsFile.Type;
export type StaticMarketsFileEncoded = typeof StaticMarketsFile.Encoded;

export const StaticMarketsFile = Schema.Struct({
  $lastUpdated: Schema.String,
  data: Schema.Array(StaticMarket),
}).annotations({ identifier: "StaticMarketsFile" });
